import * as React from 'react';
import gql from 'graphql-tag';
import AuthorizedQuery from './AuthorizedQuery';

const MY_FARMS_QUERY = gql(`
  query MyFarms {
    myFarms {
      id
      name
      geometry {
        type
        coordinates
      }
      fieldCount
    }
  }
`);

interface Props {
  children: (farms: Farm[], loading: boolean) => React.ReactNode;
}

const FarmsProvider: React.StatelessComponent<Props> = (props: Props) => (
  <AuthorizedQuery query={MY_FARMS_QUERY} fetchPolicy="network-only" onError={err => console.error(err)}>
    {({ data, loading }) => props.children(data && data.myFarms || [], loading)}
  </AuthorizedQuery>
);

export default FarmsProvider;



// WEBPACK FOOTER //
// ./src/providers/FarmsProvider.tsx